import myAxios from './axios';

class HttpRequest {
  async query({ url, options = {} }) {
    const method = (options.method || '').toString().toLowerCase();
    options.data = Object.assign({}, options.data || {});

    if (options.data && (!method || method === 'get' || method === 'delete')) {
      options.params = options.data;
      delete options.data;
    }

    const request = {
      url,
      timeout: 30 * 1000, // 默认10s请求超时
      withCredentials: false, // 默认无需凭证
      ...options
    };

    return myAxios(request)
      .then(res => {
        return res;
      })
      .catch(err => {
        console.log(`err=>api query =>${url}`);
      });
  }
}

export default new HttpRequest();



// WEBPACK FOOTER //
// ./src/services/http-request/index.js